// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1f46c961","186":"d80f0dc5","344":"8add9d3b","372":"b770e65d","377":"62724090","443":"e44d84a2","738":"05ae011a","841":"6625b2fc","856":"6fb7e60b"}[chunkId] + ".chunk.js";
};